import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Create, ThumbDownAlt, ThumbUpAlt } from "@material-ui/icons";
import { useAuth, useAccessControl } from "@airborne/react-admin";
import { useNotify, useRefresh } from "react-admin";
import { DetailButton } from "../../../../Components/DetailButton";
import { useAppDataProvider } from "../../../../dataprovider";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { SourceRequestOrder } from "../../Constant/Source";
import React from "react";

export const AcceptOrRejectColumn = (props: any) => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { user } = useAuth();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  function acceptButtonClick() {
    let record = props.record;
    record.requestStatus =
      record.requestStatus === RequestStatus.Status22 ? RequestStatus.Status30 : RequestStatus.CancellationRepairPeriod;
    dataProvider
      .updateRequestOrder(record)
      .then(result => {
        notify(`Record updated`, "success", false, true);
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {
        refresh();
      });
  }

  function rejectButtonClick() {
    let record = props.record;
    record.requestStatus = RequestStatus.Status22;
    dataProvider
      .updateRequestOrder(record)
      .then(result => {
        notify(`Record updated`, "success", false, true);
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {
        refresh();
      });
  }
  const remarkOnClick = e => {
    e.stopPropagation();
    props?.remarkAddClick?.(props?.record);
  };

  const AcceptButton = () => {
    return (
      <IconButton
        onClick={e => {
          e.stopPropagation();
          acceptButtonClick();
        }}
        style={{
          color: "#12824C",
        }}
      >
        <ThumbUpAlt />
      </IconButton>
    );
  };

  const RejectButton = () => {
    return (
      <IconButton
        onClick={e => {
          e.stopPropagation();
          rejectButtonClick();
        }}
        color="primary"
      >
        <ThumbDownAlt />
      </IconButton>
    );
  };
  const RemarkButton = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick}>
        <Tooltip TransitionComponent={Zoom} title="Core Last Update">
          <Create />
        </Tooltip>
      </IconButton>
    );
  };
  const DetailsButton = () => {
    return <DetailButton record={props.record} resource={"requestorders"} />;
  };
  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <ButtonGroup variant="text" size="small">
        <DetailsButton />
        {user?.isCustomer === false && canCreate && (
          <>
            <AcceptButton />
            {props?.record?.requestStatus === RequestStatus.Status24 && <RejectButton />}
            {props?.record?.requestStatus === RequestStatus.Status24 && <RemarkButton />}
          </>
        )}
      </ButtonGroup>
    </Box>
  );
};
export default AcceptOrRejectColumn;
